import props from '../../../../redux/props'
import { useSelector } from 'react-redux'
import Container from '../../Container/Container'

const Footer = () => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <div className="bg-beige py-6 md:py-12 relative">
      <Container>
        <div className="flex flex-col gap-3 items-center">
          <div className="flex divide-x">
            {t.footer.legalLinks.map((item, index) => (
              <a key={index} className="font-thin text-xs px-3 leading-4 uppercase" href={item.link}>
                {item.name}
              </a>
            ))}
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Footer
